import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stktq } from '../entity/Stktq-angular';

export const StkTq012List = [{ id: "0", name: "買進" }, { id: "1", name: "賣出" }]; // 買賣
export const StkTq013List = [{ id: "0", name: "新倉" }]; // 倉別
export const StkTq014List = [{ id: "0", name: "否" }, { id: "1", name: "是" }]; // 當沖
export const StkTq015List = [{ id: "0", name: "ROD" }, { id: "1", name: "FOK" }, { id: "2", name: "IOC" }]; // 委託條件
export const StkTq016List = [{ id: "0", name: "LMT限價單" }, { id: "1", name: "MKT市價單" }, { id: "2", name: "STL停損限價" }, { id: "3", name: "STP停損市價" }]; // 特別交易類型
export const StkTq028List = [{ id: "1", name: "已暫存" }, { id: "2", name: "委託失敗" }, { id: "3", name: "已刪除" }, { id: "5", name: "委託成功" }, { id: "8", name: "部分成交" }, { id: "9", name: "全部成交" }]; // 狀態
export const StkTq030List = [{ id: "0", name: "上市" }, { id: "1", name: "上櫃" }, { id: "2", name: "期貨" }, { id: "3", name: "選擇權" }, { id: "4", name: "興櫃" }, { id: "5", name: "盤中零股-上市" }, { id: "6", name: "盤中零股-上櫃" }, { id: "O", name: "海期" }, { id: "Z", name: "指數" }]; // 商品分類

@Injectable({
  providedIn: 'root'
})
export class StktqServicePkg extends JkEntityV2 {
  StkTq012List = StkTq012List;
  StkTq013List = StkTq013List;
  StkTq014List = StkTq014List;
  StkTq015List = StkTq015List;
  StkTq016List = StkTq016List;
  StkTq028List = StkTq028List;
  StkTq030List = StkTq030List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stktq();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      TQ001: '交易日期', TQ002: '帳號', TQ003: '序號', TQ004: '交易所代碼', TQ005: '商品代號', TQ006: '近月商品年月', TQ007: '遠月商品年月', TQ008: '委託價', TQ009: '委託價分子', TQ010: '委託價分母', TQ011: '觸發價', TQ011A: '觸發價分子', TQ012: '買賣', TQ013: '倉別', TQ014: '當沖', TQ015: '委託條件', TQ016: '特別交易類型', TQ017: '委託口數', TQ018: '登入代號', TQ019: '備註', TQ020: '暫存', TQ021: '失敗原因', TQ022: '價差委託', TQ023: '更新api', TQ024: '委託書號', TQ025: '委託序號', TQ026: '成交口數', TQ027: '異動時間', TQ028: '狀態', KEY0: '流程碼', TQ029: '商品名稱', TQ030: '商品分類', TQ031: '平均成交價'
    };

    this.fieldNames = 'TQ001,TQ002,TQ003,TQ004,TQ005,TQ006,TQ007,TQ008,TQ009,TQ010,TQ011,TQ011A,TQ012,TQ013,TQ014,TQ015,TQ016,TQ017,TQ018,TQ019,TQ020,TQ021,TQ022,TQ023,TQ024,TQ025,TQ026,TQ027,TQ028,KEY0,TQ029,TQ030,TQ031';
    this.fieldLengths = { TQ001: 8, TQ002: 20, TQ003: 4, TQ004: 10, TQ005: 20, TQ006: 6, TQ007: 6, TQ008: 11.3, TQ009: 11.3, TQ010: 11.3, TQ011: 11.3, TQ011A: 11.3, TQ012: 4, TQ013: 4, TQ014: 4, TQ015: 4, TQ016: 4, TQ017: 8, TQ018: 10, TQ019: 255, TQ020: 1, TQ021: 255, TQ022: 1, TQ023: 1, TQ024: 10, TQ025: 13, TQ026: 8, TQ027: 8, TQ028: 1, KEY0: 1, TQ029: 60, TQ030: 1, TQ031: 11.3 };
    this.columnDefs = [
      { field: "TQ025", headerName: "委託序號", headerTooltip: "", width: 174, cellDataType: "text", },
      { field: "TQ018", headerName: "登入代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TQ019", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "TQ020", headerName: "暫存", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "TQ021", headerName: "失敗原因", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "TQ022", headerName: "價差委託", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "TQ023", headerName: "更新api", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "TQ024", headerName: "委託書號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TQ017", headerName: "委託口數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ026", headerName: "成交口數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ027", headerName: "異動時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "TQ028", headerName: "狀態", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "KEY0", headerName: "流程碼", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TQ029", headerName: "商品名稱", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TQ030", headerName: "商品分類", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TQ031", headerName: "平均成交價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ001", headerName: "交易日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "TQ009", headerName: "委託價分子", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ002", headerName: "帳號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TQ003", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "TQ004", headerName: "交易所代碼", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TQ005", headerName: "商品代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TQ006", headerName: "近月商品年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "TQ007", headerName: "遠月商品年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "TQ008", headerName: "委託價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ016", headerName: "特別交易類型", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ010", headerName: "委託價分母", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ011", headerName: "觸發價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ011A", headerName: "觸發價分子", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ012", headerName: "買賣", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ013", headerName: "倉別", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ014", headerName: "當沖", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TQ015", headerName: "委託條件", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKTQ';
    this.isSys = false;
    this.sqlSelect = `SELECT STKTQ.*  FROM STKTQ`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY TQ001,TQ002,TQ003`;
    this.keyFields = ['TQ001', 'TQ002', 'TQ003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['TQ001', 'TQ002', 'TQ003', 'TQ004', 'TQ005', 'TQ008', 'TQ017', 'TQ018', 'TQ028', 'KEY0'];
    this.seqField = 'TQ003';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Stktq): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stktq): Promise<Stktq> {
    await super.newRecord(newItem);
    return newItem;
  }




}

